import React from 'react'

const DayScheduleFooter = ({ loading, submitData }) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-border-t tw-border-base-300 tw-px-4">
      <div className="tw-my-4 tw-flex tw-items-center tw-gap-3">
        <button
          disabled={loading}
          type="button"
          onClick={() => submitData()}
          className={`tw-cursor-pointer tw-rounded-lg tw-bg-primary tw-p-3 tw-text-sm tw-font-medium tw-text-white hover:tw-opacity-80`}
        >
          Zapisz
        </button>
      </div>
    </div>
  )
}

export default DayScheduleFooter
